export default "__VITE_ASSET__CyAGamgc__"